var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-layout"},[_c('div',{staticClass:"text"},[_vm._t("default")],2),_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":`${_vm.publicPath}img/logo.png`,"alt":"logo-nkr-motors-group"}})]),_c('div',[_c('h2',[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t("message.go_back_to_home")))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }